<template>
<v-card class="totali-container">
  <v-container grid-list-sm>
    <tot-mensile-detail :data="totToShow" />
    <v-dialog scrollable width="90%" v-model="showYear">
      <v-card>
        <v-card-title class="headline">
          Traguardi mensili
        </v-card-title>
        <v-card-text>
          <tot-mensile-detail :dialog="true" :data="totaleMensile" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            flat
            @click="showYear = false"
          >
            Chiudi
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</v-card>
</template>

<script>
import Stats from '@/mixins/stats';
import moment from 'moment';
import TotMensileDetail from './TotMensileDetail.vue';

export default {
  name: 'totale-mensile',
  mixins: [Stats],
  components: { TotMensileDetail },
  data() {
    return {
      showYear: false,
    };
  },
  methods: {
    async refresh(type = null) {
      if (type === 'SESSION' || type === 'LOCALI') {
        this.totaleMensileReload();
      }
    },
  },
  computed: {
    totToShow() {
      const curr = moment().month() + 1;
      return this.totaleMensile.filter(({ mese }) => {
        if (curr < 3) return mese <= 3;
        return mese <= curr && mese > curr - 3;
      }).reverse();
    },
  },
};
</script>

<style lang="stylus" scoped>
.totali-container.v-card
  display flex
  .container
    padding 0
div >>> .v-card__text
  padding 0
</style>
